/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Location } from '@angular/common';
import { environment } from '@app/environments/environment';

// Kept apart from the data service, so the app-wide auth interceptor can read them without loading the sharing code.

const RESOURCE_API_ROOT = environment.localServiceOverrides?.resourcesBaseUrl || environment.apiRootUrl || '';
export const SHARES_ROOT = Location.joinWithSlash(RESOURCE_API_ROOT, '/shares');
/** Open to anyone: the auth interceptor sends no token here, since a stale one would be turned away. */
export const PUBLIC_SHARES_ROOT = Location.joinWithSlash(SHARES_ROOT, '/public');
export const COURSES_ROOT = Location.joinWithSlash(RESOURCE_API_ROOT, '/courses');
